export default "__VITE_ASSET__3496a963__"